import { StyleSheet } from 'react-native';
import { themes } from 'src/theme/theme';

export const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: themes.light.white[1],
    justifyContent: 'center',
    alignItems: 'center',
  },
  gif: {
    width: 160,
    height: 160,
    marginBottom: 24,
  },
  text: {
    textAlign: 'center',
  },
});
